<template>
  <div :class="['trade-tabs-switcher', { 'active' : isHover }]">
    <exc-header-nav-item
      is-mobile-trade
      color-main-icon
      @toggle="(v) => isHover = v"
    >
      <template #name>
        <slot v-bind="{ value }" name="selected">
          <span
            :class="{
              'txt--10px': !bigText,
              'txt--26px txt--36px--l txt--height-34px txt--height-44px--l txt--main txt--bold': bigText
            }"
          >
            {{ value.label }}
          </span>
        </slot>
      </template>
      <template #dropdown>
        <div class="bg--color-01">
          <exc-header-dropdown-item
            v-for="btn in buttons"
            :key="btn.value"
            @click="toggleTab(btn)"
          >
            <template #name>
              <slot v-bind="{ btn }" name="item">
                <span
                  :class="{
                    'txt--weight-500 txt--16px txt--height-20px txt--color-04': bigText
                  }"
                >{{ btn.label }}</span>
              </slot>
            </template>
          </exc-header-dropdown-item>
        </div>
      </template>
    </exc-header-nav-item>
  </div>
</template>

<script>
import { ExcHeaderNavItem, ExcHeaderDropdownItem } from '@/components/common'
import { LabeledValue } from '@/data-objects/props/LabeledValue'

export default {
  name: 'TradeTabsSwitcher',
  components: {
    ExcHeaderNavItem,
    ExcHeaderDropdownItem,
  },
  props: {
    buttons: {
      type: Array,
      required: true,
    },
    value: {
      type: LabeledValue,
      required: true,
    },
    bigText: {
      type: Boolean,
      default: false,
    },
    colorMainIcon: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      isHover: false,
    }
  },
  methods: {
    toggleTab (btn) {
      this.title = btn
      this.$emit('input', btn)
    },
  },
}
</script>

<style lang="scss" scoped>
.trade-tabs-switcher {
  border: 1px solid $c-transp-02;
  border-radius: toRem(40px);

  transition: 0.3s;
  transition-timing-function: ease;
  transition-delay: 0s;
  transition-property: all;

  &::v-deep {
    .exc-header-nav-item__name {
      padding: 4px 10px;
    }

    span {
      font-weight: 500;
      font-size: toRem(14px);
      line-height: toRem(18px);
      color: $c-color-04;
    }
  }
}

.active {
  border: 1px solid var(--c-main-lighter, #4a84dc);
}
</style>
